import { render, staticRenderFns } from "./CustomerActiveTodoListSidedbar.vue?vue&type=template&id=1fff335c&scoped=true&"
import script from "./CustomerActiveTodoListSidedbar.vue?vue&type=script&lang=js&"
export * from "./CustomerActiveTodoListSidedbar.vue?vue&type=script&lang=js&"
import style0 from "./CustomerActiveTodoListSidedbar.vue?vue&type=style&index=0&id=1fff335c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fff335c",
  null
  
)

export default component.exports